import React, {Component} from 'react'
import {observer} from 'mobx-react'

import Field from '../../struct/Field'
import InputText from '../../control/DependentInputText'

@observer export default class ProfileWaSettings extends Component {
    render() {
        /** @type {ProfileSettingsContext} */
        const context = this.props.context
        const profile = context.profile

        return (
            <div>
                <Field label="Название профиля">
                    <InputText
                        value={profile.name}
                        onChange={e => profile.name = e.target.value}
                        state={context.form_state}
                    />
                </Field>
            </div>
        )
    }
}